const normalisePaymentMode = (mode) =>
  String(mode || '').trim().toLowerCase().replace(/\s+/g, '_');

export const shipmentHasUnremittedPaid = (shipment) => {
  if (!shipment) return false;
  const outstanding = Number(shipment.paid_remit_outstanding);
  if (!Number.isNaN(outstanding) && outstanding > 0.009) return true;

  const mode = normalisePaymentMode(shipment.mode_of_payment);
  if (mode !== 'paid' && mode !== 'paid_balance') return false;

  const paid = Number(shipment.paid_amount ?? 0);
  const remitted = Number(
    shipment.paid_remitted_amount ?? shipment.paid_remit_amount ?? 0,
  );
  return paid > remitted + 0.009;
};

/** True when company setting requires paid remittance before ML dispatch. */
export const companyRequiresPaidSettlementBeforeMl = (user) =>
  user?.require_paid_settlement_before_ml !== false;

/** Disable paid GC selection on dispatch only when the company rule is ON. */
export const isShipmentDisabledForMl = (shipment, user, requirePaidBeforeMl = null) => {
  if (shipment?.is_deleted) return true;
  const ruleOn = requirePaidBeforeMl ?? companyRequiresPaidSettlementBeforeMl(user);
  return ruleOn && shipmentHasUnremittedPaid(shipment);
};

export const getUnremittedPaidShipments = (shipments = [], selectedIds = []) => {
  const idSet = new Set((selectedIds || []).map((id) => String(id)));
  return (shipments || []).filter((shipment) => {
    const shipmentId = String(shipment.shipment_id || shipment.id || '');
    if (!idSet.has(shipmentId)) return false;
    return shipmentHasUnremittedPaid(shipment);
  });
};

export const mlCreationHardBlocked = (mlCreationBlock = {}) => Boolean(mlCreationBlock.blocked);

export const mlCreationHasOutstanding = (mlCreationBlock = {}) =>
  Boolean(
    mlCreationBlock.has_outstanding
    || Number(mlCreationBlock.amount_outstanding || 0) > 0,
  );

export const shouldShowMlPaidSettlementGate = (mlCreationBlock = {}) =>
  mlCreationHardBlocked(mlCreationBlock) || mlCreationHasOutstanding(mlCreationBlock);
